import React from 'react';
import Map from "../GoPlanner/components/Map";

export default ({ lat, lng, kml, hideLabel }) => {
    const markers = lat && lng ? [
        {position: { lat, lng }}
    ] : [];

    return (
        <Map
            markers={markers}
            kml={kml}
            hideLabel={hideLabel}
            preDefinedZoom={true}
        />
    )
}
